import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationAR from './locales/ar.json'
import translationEN from './locales/en.json'
import translationFR from './locales/fr.json'
import { applyDocumentDirection, normalizeAppLanguage } from './helpers/documentLocale'

const resources = {
  ar: {
    translation: translationAR,
  },
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Never fall English → Arabic (or vice versa): missing keys must not
    // surface the other locale's labels when the user explicitly chose a language.
    fallbackLng: {
      fr: ['en'],
      en: [],
      ar: [],
      default: ['ar'],
    },
    supportedLngs: ['ar', 'en', 'fr'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  })

applyDocumentDirection(i18n.language)

i18n.on('languageChanged', (lng) => {
  applyDocumentDirection(normalizeAppLanguage(lng))
})

export default i18n
